export const Constants = {
  // Development APIs
  // BASE_API_URL: "http://10.10.100.5:6661/api/",
  // SERVER_URL: "http://10.10.100.5:6661/",
  // SignalR_URL: "http://10.10.100.5:7780/",
  // WEB_APP_URL: "http://10.10.100.5:6662",

  // Test APIs
  // BASE_API_URL: "http://10.10.100.5:7771/api/",
  // SERVER_URL: "http://10.10.100.5:7781/",
  // SignalR_URL: "http://10.10.100.5:7779/",
  // WEB_APP_URL: "http://10.10.100.5:7772",

  // Live APIs
  // BASE_API_URL: "https://businessapi.dome-care.com/api/",
  // SERVER_URL: "https://files.dome-care.com/",
  // SignalR_URL: "https://notification.dome-care.com/",
  // WEB_APP_URL: "https://business.dome-care.com",

  USER_BLOCKED: 405,
  TOKEN_STORAGE_KEY: "authToken",
  Under_Construction: false,
  VERSION_2: true,
} as const;

export const Methods = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
} as const;

export type Method = (typeof Methods)[keyof typeof Methods];
